import {AbstractVisualFeature, allVisuals} from '../visual-feature.js';

import {bettingCenterFactory} from './betting-center.factory';

import PALETTE_SCHEMA from './betting-center.palette-schema.yaml';

class BettingCenterFeature extends AbstractVisualFeature {
    get name() {
        return 'Betting Center';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return bettingCenterFactory(PALETTE);
    }
}

export const BettingCenter = new BettingCenterFeature(allVisuals);
